import { render, staticRenderFns } from "./Decimals.vue?vue&type=template&id=549e26d8"
import script from "./Decimals.vue?vue&type=script&lang=ts"
export * from "./Decimals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('549e26d8')) {
      api.createRecord('549e26d8', component.options)
    } else {
      api.reload('549e26d8', component.options)
    }
    module.hot.accept("./Decimals.vue?vue&type=template&id=549e26d8", function () {
      api.rerender('549e26d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/Decimals.vue"
export default component.exports